// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__1geqC","lds-ellipsis1":"styles_lds-ellipsis1__POnfX","lds-ellipsis2":"styles_lds-ellipsis2__-EIBz","lds-ellipsis3":"styles_lds-ellipsis3__5FHll"};